import { Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppValidators } from 'src/app/common/appValidators';

export interface SetQuarantineStateConfirmationData {
  itemName: string;
  quarantineStatus: string;
}

@Component({
  selector: 'app-action-set-resource-quarantine-state',
  templateUrl: './action-set-resource-quarantine-state.component.html',
  styleUrls: ['./action-set-resource-quarantine-state.component.scss'],
})
export class ActionSetResourceQuarantineStateComponent {
  public textValidationControl: UntypedFormControl;

  constructor(
    public dialogRef: MatDialogRef<ActionSetResourceQuarantineStateComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: SetQuarantineStateConfirmationData
  ) {
    this.textValidationControl = new UntypedFormControl('', [
      Validators.required,
      AppValidators.textValidation(data.quarantineStatus),
    ]);
  }

  public yesClicked(): void {
    if (this.textValidationControl.valid) {
      this.dialogRef.close(true);
    }
  }

  public noClicked() {
    this.dialogRef.close();
  }
}
